module.exports = __webpack_public_path__ + "static/img/ftmob.d9cd74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftmob.png
// module id = J926
// module chunks = 0